up.compiler('[print="true"]', (_element) => {
  window.print()
})